/**
 * @typedef {Object} SignUp
 * @prop {string} urlUS
 * @prop {string} urlEU
 */

/**
 * @typedef {Object} PDGlobalObject
 * @prop {string} appVersion
 * @prop {SignUp?} signUp
 * @prop {string} googleAnalyticsId
 * @prop {string} segmentWriteKey
 * @prop {boolean} adBlock
 * @prop {string} lang
 * @prop {{breakpoint: string}} nav
 * @prop {{country:string, region:string, continent:string}} cfData
 */

/** @typedef {import('@bugsnag/js').default} Bugsnag */

/**
 * @typedef {Object} PDGlobals
 * @prop {PDGlobalObject} pd
 * @prop {Bugsnag} Bugsnag
 * @prop {any} analytics
 * @prop {any} ga
 * @prop {Function} onYouTubeIframeAPIReady
 * @prop {string} OnetrustActiveGroups
 * @prop {any} OneTrust
 * @prop {any} _wq
 * @prop {{"api"?: Record<string, function>}} drift
 * @prop {() => void} OptanonWrapper
 * @prop {Record<string, function>} turnstile
 */

/**
 * @typedef {PDGlobals & Window & typeof globalThis} PDWindow
 */

export const win = /** @type {PDWindow} */ (window);
